import React from 'react';
import { Form, Input, Checkbox } from 'antd';

const InputGroup = Input.Group;

export default function Footer(props) {
    return (
        <div className="row">
            <div className={"col-md-6"}>
                <Form.Item>
                    <InputGroup compact>
                        <Form.Item style={{ width: '33.33%' }}>
                            <Checkbox
                                checked={props.formValues.flagExportacion}
                            >
                                Exportación
                            </Checkbox>
                        </Form.Item>
                        <Form.Item style={{ width: '33.33%' }}>
                            <Checkbox
                                checked={props.formValues.flagPercepcion}
                            >
                                Percepción
                            </Checkbox>
                        </Form.Item>
                        <Form.Item style={{ width: '33.33%' }}>
                            <Checkbox
                                checked={props.formValues.flagDetraccion}
                            >
                                Detracción
                            </Checkbox>
                        </Form.Item>
                    </InputGroup>
                </Form.Item>
            </div>
            <div className="col-md-3 form-group">
                <Form.Item label='' style={{ display: props.formValues.flagDetraccion ? '' : 'none' }}>
                    <Input readOnly
                        value={props.formValues.nombreDetraccion}
                    />
                </Form.Item>
            </div>
            <div className="col-md-3 pt-10">
                <div className="col text-right mb-5" style={{ display: props.formValues.flagPercepcion ? "" : "none" }}>
                    <div className="total-inline">
                        <label>Porcentaje Percepción</label>
                        <div>{props.formValues.porcentajePercepcion.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5" style={{ display: props.formValues.flagDetraccion ? "" : "none" }}>
                    <div className="total-inline">
                        <label>Porcentaje Detracción</label>
                        <div>{props.formValues.porcentajeDetraccion.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Detalle</label>
                        <div>{props.formValues.totalDetalle.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Importe Descuento</label>
                        <div>{props.formValues.importeDescuento.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Sub Total</label>
                        <div>{props.formValues.subTotal.toFixed(2)}</div>
                    </div>
                </div>
                {
                    props.formValues.totalDetalleExonerado > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Exonerada</label>
                                <div>{props.formValues.totalDetalleExonerado.toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                {
                    props.formValues.totalDetalleInafecto > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Inafecta</label>
                                <div>{props.formValues.totalDetalleInafecto.toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>IGV</label>
                        <div>{props.formValues.igv.toFixed(2)}</div>
                    </div>
                </div> 

                {
                    props.formValues.totalDetalleGratuito > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Gratuita</label>
                                <div>{props.formValues.totalDetalleGratuito.toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.formValues.totalDetalleISC > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>ISC</label>
                                <div>{props.formValues.totalDetalleISC.toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total</label>
                        <div>{props.formValues.total.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5" style={{ display: props.formValues.flagPercepcion ? "" : "none" }}>
                    <div className="total-inline">
                        <label>Importe Persepción</label>
                        <div>{props.formValues.importePercepcion.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5" style={{ display: props.formValues.flagPercepcion ? "" : "none" }}>
                    <div className="total-inline">
                        <label>Total Percepción</label>
                        <div>{props.formValues.totalPercepcion.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5" style={{ display: props.formValues.flagDetraccion ? "" : "none" }}>
                    <div className="total-inline">
                        <label>Importe Detracción</label>
                        <div>{props.formValues.importeDetraccion.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5" style={{ display: props.formValues.flagDetraccion ? "" : "none" }}>
                    <div className="total-inline">
                        <label>Total Detracción</label>
                        <div>{props.formValues.totalDetraccion.toFixed(2)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}